import { createElement } from 'react';
import { Radio } from '@alifd/next';
import './index.scss';
const OadpRadioGroup = function OadpRadioGroup({ name, dataSource, defaultValue, size, shape, direction, disabled, ...otherProps }) {
    return (createElement(Radio.Group, Object.assign({ name: name, dataSource: dataSource, defaultValue: defaultValue, size: size, shape: shape, direction: direction, disabled: disabled }, otherProps)));
};
export default OadpRadioGroup;
